import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/', 
      redirect:'/index',
    },
    {
      path:'/login',
      name:'login',
      component:resolve =>{
        require(['@/components/login'],resolve)
      },
    },
    {
      path:'/merchant',
      name:'merchant',
      component:resolve =>{
        require(['@/components/merchant'],resolve)
      },
    },
    {
      path:'/index',
      name:'index',
      component:resolve =>{
        require(['@/components/index'],resolve)
      },
    },
    {
      path:'/from/app',
      name:'formApp',
      component:resolve =>{
        require(['@/components/formApp'],resolve)
      },
    }
  ],
  mode:"history" //ȥ����ַ����#��
})



// WEBPACK FOOTER //
// ./src/router/index.js